import React, { Suspense } from 'react';

import { inject, observer } from 'mobx-react';
import { Spinner } from '@bringg/react-components';
import { getRootEnv } from '@bringg-frontend/bringg-web-infra';

import Login from './features/login/login';
import { AuthStore } from './stores/auth-store/auth-store';

import './App.scss';

interface Props {
	authStore?: AuthStore;
	Routes: React.LazyExoticComponent<React.ComponentType<any>>;
}
const App = ({ authStore, Routes }: Props) => {
	if (getRootEnv().isDev && !authStore.isLoggedIn) {
		return <Login />;
	}

	return (
		<Suspense fallback={<Spinner className="flex-centered" />}>
			<Routes />
		</Suspense>
	);
};

export default inject('authStore')(observer(App));
